import { toLocalMidnight } from '~/lib/util/date.util';
import InquiryPlainTextCell from './InquiryPlainTextCell';
import { DateTime } from 'luxon';

interface MedicalAppointmentDateCellProps {
  appointmentDate: string;
  id: string;
}

const MedicalAppointmentDateCell = ({
  appointmentDate,
  id,
}: MedicalAppointmentDateCellProps) => {
  const dateValue = DateTime.fromJSDate(
    new Date(toLocalMidnight(new Date(appointmentDate))),
  ).toLocaleString(DateTime.DATE_MED);
  return (
    <InquiryPlainTextCell id={id}>
      {appointmentDate ? dateValue : null}
    </InquiryPlainTextCell>
  );
};

export default MedicalAppointmentDateCell;
